export const Alfred = {
  pinMinLength: 4,
  pinMaxLength: 10,
  defaultLength: 6
}

export const LockProviders = {
  ALFRED: 0,
  YALE: 1,
  ICT: 2,
  SALTO: 4,
  ICT_SALTO_SPACE: 6,
  ICT_ALFRED: 8,
  ICT_YALE: 9,
  ICT_SALTO_ALFRED: 10,
  BRIVO_ALFRED: 11,
  SALTO_ALFRED: 12,
  ICT_SALTO_SLAVE: 13,
  DORMAKABA: 21,
  BRIVO_YALE: 22,
  ICT_ALLEGION: 23,
};

export const ICT_LOCK_PROVIDERS = [
  LockProviders.ICT,
  LockProviders.ICT_SALTO_SPACE,
  LockProviders.ICT_ALFRED,
  LockProviders.ICT_YALE,
  LockProviders.ICT_SALTO_ALFRED,
  LockProviders.ICT_SALTO_SLAVE,
  LockProviders.ICT_ALLEGION
];

export const isICTLockProvider = (lockProvider) =>
  ICT_LOCK_PROVIDERS.includes(Number(lockProvider));

export const YALE_LOCK_PROVIDERS = [
  LockProviders.YALE,
  LockProviders.ICT_YALE,
  LockProviders.BRIVO_YALE
];

export const ALFRED_LOCK_PROVIDERS = [
  LockProviders.ALFRED,
  LockProviders.ICT_ALFRED,
  LockProviders.ICT_SALTO_ALFRED,
  LockProviders.BRIVO_ALFRED,
  LockProviders.SALTO_ALFRED
];

export const isYaleLockProvider = (lockProvider) =>
  YALE_LOCK_PROVIDERS.includes(Number(lockProvider));

export const isAlfredLockProvider = (lockProvider) =>
  ALFRED_LOCK_PROVIDERS.includes(Number(lockProvider));

// PIN history is only kept for Yale and Alfred locks
export const supportsPinHistory = (lockProvider) =>
  lockProvider !== undefined &&
  lockProvider !== null &&
  (isYaleLockProvider(lockProvider) || isAlfredLockProvider(lockProvider));

// Battery info (units/suites columns, Battery Status tab) is hidden for Yale buildings in these orgs
const HIDE_YALE_BATTERY_ORG_IDS = [166];

export const shouldHideBatteryLevel = (building) =>
  HIDE_YALE_BATTERY_ORG_IDS.includes(Number(building?.org_id)) &&
  isYaleLockProvider(building?.config?.lock_provider);

// codes type_id
export const PIN_TYPE_LABELS = {
  1: 'Master PIN',
  2: 'User PIN',
  3: 'Guest PIN'
};

export const BRIVO_LOCK_PROVIDERS = [
  LockProviders.BRIVO_ALFRED,
  LockProviders.BRIVO_YALE
];

export const isBrivoLockProvider = (lockProvider) =>
  BRIVO_LOCK_PROVIDERS.includes(Number(lockProvider));
